import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { SharedModule } from 'shared/shared.module';
import { GlobalPagesRoutingModule } from './global-pages-routing.module';
import { PageComponent } from 'shared/page/page.component';

import { SegmentNavigationPageComponent } from './_segment-navigation-page.component';
import { BaseGlobalSegmentComponent } from './common/_base-global-segment.component';

// pages
import { BrandInformationModule } from './brand-information/brand-information.module';
import { AccountInformationModule } from './account-information/account-information.module';
import { NgUploaderModule } from 'shared/ngx-uploader/modules/ngx-uploader.module';

import { InformationPageComponent } from './information-page/information-page.component';
import { BeforeSaveModalComponent } from './before-save-modal/before-save-modal.component';
import { GlobalPageComponent } from './global-page.component';
import { FileUploaderComponent } from './file-uploader/file-uploader.component';

import { InformationPageService } from './information-page/information-page.service';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    SharedModule,
    GlobalPagesRoutingModule,
    BrandInformationModule,
    AccountInformationModule,
    NgUploaderModule
  ],
  declarations: [
    SegmentNavigationPageComponent,
    BaseGlobalSegmentComponent,

    GlobalPageComponent,
    InformationPageComponent,
    BeforeSaveModalComponent,
    PageComponent,
    FileUploaderComponent,
  ],
  exports: [],
  providers: [InformationPageService],
  schemas: [
    NO_ERRORS_SCHEMA,
  ]
})
export class GlobalPagesModule { }
